function userFromAuth(user) {
  const auth = { ...user, ...user.providerData[0] };
  const { email, photoURL } = auth;
  return { auth, email, photoURL };
}

export default userFromAuth;
